module.exports = __webpack_public_path__ + "img/billing-step-3-bg.a7242c37.svg";